<img
  class="app__logo"
  src="assets/images/app-logo.svg"
  [attr.width]="size"
  [attr.height]="size"
  alt="app"
/>
